/* eslint-disable no-undef */
import { getGraphQLClient } from 'utils/graphQL/client';
export const userServiceClient = getGraphQLClient({
    url: USER_SERVICE_URL,
});
